import queryString from 'query-string';
import { get, post, del } from './apiUtils';

const defaultUrl = '/CategoriesTR/';

export default {
  getCategoryTRList: () => get(defaultUrl),
  saveCategoryTR: data => post(`${defaultUrl}`, data),
};
